import { combineEpics } from 'redux-observable'

import Epic from '../Epic'
import join from './join'
import loadConfig from './loadConfig'
import loadCredentials from './loadCredentials'
import loadMapObject from './loadMapObject'
import loadPhotoComments from './loadPhotoComments'
import loadUser from './loadUser'
import login from './login'
import postPhotoComment from './postPhotoComment'
import saveCredentials from './saveCredentials'
import signUp from './signUp'
import signUpGuest from './signUpGuest'
import updatePhoto from './updatePhoto'
import uploadPhoto from './uploadPhoto'

export default combineEpics<Epic>(
  loadConfig,
  loadCredentials,
  saveCredentials,
  loadUser,
  signUp,
  signUpGuest,
  join,
  loadMapObject,
  loadPhotoComments,
  postPhotoComment,
  uploadPhoto,
  updatePhoto,
  login
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/operations/index.ts